// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
} from "firebase/messaging";

// Replace the following with your Firebase project configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDkEqi1dSUIuQHWbKNHcS2eiRFNRBDm1AE",
  authDomain: "baby-tracker-54238.firebaseapp.com",
  projectId: "baby-tracker-54238",
  storageBucket: "baby-tracker-54238.firebasestorage.app",
  messagingSenderId: "1076267204770",
  appId: "1:1076267204770:web:25e20d4041222798add7fb",
  measurementId: "G-HVFE62ZRZG",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

const messaging = getMessaging(app);

export { app, db, auth, storage, messaging, getToken, onMessage, deleteToken };
